"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDafOrganizationEmailTheme = exports.buildDafEmailCopy = void 0;
const email_theme_tokens_1 = require("../../helpers/email-theme-tokens");
const email_templates_1 = require("../../internationalization/locales/email-templates");
const buildDafEmailCopy = ({ locale, provider, organization, amount, donor, grantOrganization, }) => {
    const labels = (0, email_templates_1.getEmailLabels)(locale);
    const values = { provider, organization, amount, donor };
    const format = (label, variables = values) => label.replace(/\{(\w+)\}/g, (placeholder, key) => variables[key] ?? placeholder);
    return {
        reminderInstructions: format(labels.dafDonorReminderInstructions),
        reminderInstructionsPrefix: format(labels.dafReminderInstructionsPrefix),
        reminderFollowup: format(labels.dafDonorReminderFollowup),
        grantDescription: format(labels.dafDonationTo, { ...values, organization: grantOrganization ?? organization }),
        orgReminderDescription: format(labels.dafOrgReminderBody),
        receivedDescription: format(labels.dafReceivedDescription),
    };
};
exports.buildDafEmailCopy = buildDafEmailCopy;
const getDafOrganizationEmailTheme = () => {
    const organizationTheme = (0, email_theme_tokens_1.getOrgFacingEmailTheme)();
    const theme = (0, email_theme_tokens_1.resolveEmailThemeTokens)(organizationTheme.brandFilledBg, "light");
    return {
        ...organizationTheme,
        ...theme,
        canvas: theme.sSupershy,
        headerText: theme.tIntense,
        bodyText: theme.tModerate,
        brandFilledBg: theme.ctaBg,
        brandFilledText: theme.ctaText,
    };
};
exports.getDafOrganizationEmailTheme = getDafOrganizationEmailTheme;
